import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=4374ba65&scoped=true&"
import script from "./aboutUs.js?vue&type=script&lang=js&"
export * from "./aboutUs.js?vue&type=script&lang=js&"
import style0 from "./aboutUs.css?vue&type=style&index=0&id=4374ba65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374ba65",
  null
  
)

export default component.exports